import { getEasyClaimAuthorizationHeaders } from '../easyclaim.app.configuration/ciapiAuthorization';
import { getEasyClaimEnv } from '../easyclaim.app.configuration/env';
import { blobToDataURL } from '../easyclaim.app.libs/blobToDataUrl';

export interface FetchLogoParams {
	caseId: string;
	signal?: AbortSignal;
}

/**
 * The logo is exposed as a data URL (not a `blob:` object URL) because WebKit on iOS
 * (notably Chrome/WKWebView) fails to load object URLs that are revoked early or created
 * from IndexedDB-persisted blobs (`WebKitBlobResource error 1`).
 */
export interface FetchLogoResult {
	dataUrl: string;
}

export async function fetchLogo({ caseId, signal }: FetchLogoParams): Promise<FetchLogoResult> {
	const { basePath, apiKey } = getEasyClaimEnv();
	const url = new URL(`${basePath}/api/v1/logo/any`);

	url.searchParams.set('caseId', caseId);

	const response = await fetch(url, {
		headers: {
			'x-apikey': apiKey,
			...getEasyClaimAuthorizationHeaders(),
		},
		signal,
	});

	if (!response.ok) {
		throw new Error(`Logo request failed with status ${response.status}`);
	}

	const blob = await response.blob();

	return { dataUrl: await blobToDataURL(blob) };
}
